import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

export const useDebugAccessQuery = (enabled = false) =>
  useQuery({
    enabled,
    queryFn: async () => {
      const response = await apiClient.client.get<{ allowed: boolean }>('/me/debug-access')
      return response.data
    },
    queryKey: meKeys.debugAccess,
    staleTime: 10 * 60 * 1000,
  })
